import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../../helpers/request';

const errorMessage = 'Не удалось изменить этап помещения';

const mutationFn = ({ addressId, stepAddressLifeCycleId }) => {
  return request.put(
    'FlatsGrid/change_step_address_life_cycle',
    { addressId, stepAddressLifeCycleId },
    errorMessage,
    'Error',
    undefined
  );
};

export const useChangeRoomStep = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') {
        return;
      }

      if (typeof data.success === 'boolean' && data.success === false) {
        message.error(data.message ?? errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};
